/**
 * wyvio-ui · Card, MicroLabel, Toolbar, SegmentedControl
 * ─────────────────────────────────────────────────────
 * Primitives génériques réutilisées sur toutes les pages produit.
 */

// Micro-label uppercase (utilisé pour titrer les sections silencieusement)
export const MicroLabel = ({ children, className = "", ...rest }) => (
  <p
    className={[
      "text-[10.5px] font-semibold uppercase tracking-[0.18em]",
      "text-[#9CA3AF] dark:text-[#525252]",
      className,
    ].join(" ")}
    {...rest}
  >
    {children}
  </p>
);

// Carte surface neutre — brique de base de tout ce qui n'est pas un bouton
export const Card = ({ interactive = false, className = "", children, ...rest }) => (
  <div
    className={[
      "rounded-3xl bg-white dark:bg-[#111111]",
      "border border-[#EEF2F5] dark:border-[#262626]",
      "transition-all duration-200 ease-out",
      interactive
        ? "hover:border-[#DCE1E7] dark:hover:border-[#3A3A3A] hover:-translate-y-[1px] cursor-pointer"
        : "",
      className,
    ].join(" ")}
    {...rest}
  >
    {children}
  </div>
);

// Row plate (liste) — variante Card à radius plus faible
export const RowCard = ({ interactive = true, className = "", children, ...rest }) => (
  <div
    className={[
      "rounded-2xl bg-white dark:bg-[#111111]",
      "border border-[#EEF2F5] dark:border-[#262626]",
      "transition-all duration-200 ease-out",
      interactive
        ? "hover:border-[#DCE1E7] dark:hover:border-[#3A3A3A] cursor-pointer"
        : "",
      className,
    ].join(" ")}
    {...rest}
  >
    {children}
  </div>
);

// Toolbar en haut de page (une seule par page)
export const Toolbar = ({ left, right, className = "" }) => (
  <div
    className={[
      "flex items-center justify-between gap-4",
      className,
    ].join(" ")}
    data-testid="wyvio-toolbar"
  >
    <div className="flex items-center gap-2 min-w-0">{left}</div>
    <div className="flex items-center gap-2 shrink-0">{right}</div>
  </div>
);

// Segmented control (Moi / Agence, filtres, etc.)
export const SegmentedControl = ({ value, onChange, options = [], testId }) => (
  <div
    data-testid={testId}
    className="inline-flex rounded-full border border-[#EEF2F5] dark:border-[#262626] bg-white dark:bg-[#111111] p-1"
  >
    {options.map(({ key, label }) => {
      const active = value === key;
      return (
        <button
          key={key}
          onClick={() => onChange(key)}
          data-testid={testId ? `${testId}-${key}` : undefined}
          className={[
            "h-8 px-4 rounded-full text-[12px] font-semibold",
            "transition-all duration-200 ease-out whitespace-nowrap",
            active
              ? "bg-[#0A0A0A] dark:bg-white text-white dark:text-[#0A0A0A]"
              : "text-[#9CA3AF] dark:text-[#737373] hover:text-[#0A0A0A] dark:hover:text-white",
          ].join(" ")}
        >
          {label}
        </button>
      );
    })}
  </div>
);
